import { createSlice } from "@reduxjs/toolkit";
import { getKeyperAssets } from "./keyperAssetsAction";

interface KeyperAsset {
  id: number;
  name?: string;
  description?: string;
  type?: string;
  statusType?: string;
  registrationType?: string;
  attributeValue1?: string;
  attributeValue2?: string;
  attributeValue3?: string;
  fobNumber?: number;
  active?: boolean;
  checkoutDate?: string;
}

interface KeyperAssetsState {
  data: KeyperAsset[];
  totalRecord: number;
  currentPage: number;
  totalPages: number;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

const initialState: KeyperAssetsState = {
  data: [],
  totalRecord: 0,
  currentPage: 1,
  totalPages: 1,
  isLoading: false,
  isSuccess: false,
  errorMessage: "",
};

export const keyperAssetsList = createSlice({
  name: "keyperAssetsList",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getKeyperAssets.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(getKeyperAssets.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data?.assets ?? [];
        state.totalRecord = payload.data?.pagination?.total ?? 0;
        state.currentPage = payload.data?.pagination?.page ?? 1;
        state.totalPages = payload.data?.pagination?.pages ?? 1;
        state.isSuccess = true;
      })
      .addCase(getKeyperAssets.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage =
          (action.payload as string) ||
          action.error?.message ||
          "Failed to fetch Keyper assets";
      });
  },
});

export default keyperAssetsList.reducer;
